import React, { useState, useEffect } from 'react';
import { PDFDownloadLink, BlobProvider } from '@react-pdf/renderer';
import Doc2 from '../Components/Doc2';
import GaugeChart from '../Components/GaugeChart';
import printJS from 'print-js'
import { Container, Row, Col, Alert, Button, Card } from 'react-bootstrap';
import { pdfButtons, alertTexts } from '../Data/data';
import HR from '../Components/HR';
import Paragraph from '../Components/Paragraph';
import { adjustResults } from '../Data/data';

const AdjustReady = (props) => {
  const [resultText, setResultText] = useState(adjustResults.yellow)
  const [show, setShow] = useState(false)
  const [show2, setShow2] = useState(false)

  useEffect(() => {
    if(props.avg <= 0.4) {
    setResultText(adjustResults.red)
    } else if(props.avg > 0.4 && props.avg < 0.7) {
    setResultText(adjustResults.yellow)
    } else if(props.avg >= 0.7) {
    setResultText(adjustResults.green)
    }

    if(show === true) {
    document.getElementById("returnHome").focus()
    window.scrollTo(0, 950)
    } 
    if(show2 === true) {
    document.getElementById("feedback").focus()
    window.scrollTo(0, 950)
    }
    if(!show && !show2) window.scrollTo(0, 0)
  },[props, show, show2])

  return (
    <Container role="main" className="content" fluid>
      <Row className="justify-content-center m-auto">
        <Col xxl={6} md={8} xs={12} className="">
          <Card className="mb-4 border-dark">
            {
              props.avg <= 0.4 &&
                <Card.Title className="resultTitle justify-content-center m-auto p-2">{adjustResults.red[0]}</Card.Title>
            }
            {
              (props.avg > 0.4 && props.avg < 0.7 ) &&
                <Card.Title className="resultTitle justify-content-center m-auto p-2">{adjustResults.yellow[0]}</Card.Title>
            }
            {
              props.avg >= 0.7 &&
                <Card.Title className="resultTitle justify-content-center m-auto p-2">{adjustResults.green[0]}</Card.Title>
            }
          </Card>
          <Container className="adjustChart">
            <GaugeChart all={props.all} />
          </Container>
          { 
            <Container className="text-center" fluid>
              <PDFDownloadLink document={<Doc2 all={props.all} targetList={props.targetList} text={resultText} />} fileName="valintani.pdf" >{({ _blob, _url, loading, _error }) =>
                loading ? <Paragraph text="Lataa..."/> : <Button className="resultItem secButton w-25 m-1">{pdfButtons.download}</Button> 
              }</PDFDownloadLink>
              <BlobProvider document={<Doc2 all={props.all} targetList={props.targetList} text={resultText} />} fileName="valintani.pdf" >{({ _blob, url, loading, _error }) =>
                loading ? <Paragraph text="Lataa..."/> : <Button onClick={() => printJS(url)} className="resultItem printButton secButton w-25 m-1">{pdfButtons.print}</Button>
              }</BlobProvider>
            </Container>
          }
        </Col>
      </Row>
      <Row className="justify-content-center m-auto pt-5">
        <Button onClick={() => setShow(true)} variant="danger" className="resultItem m-2 col-3 border-dark">{alertTexts.returnAlert.returnButton}</Button>
      </Row>
      <Row className="justify-content-center m-auto">
        <Button onClick={() => setShow2(true)} className="resultItem btn mainButton m-2 col-3">{alertTexts.feedbackAlert.feedButton}</Button>
      </Row>
      <Row id="returnHome" className="resultItem w-25 m-auto">
        <Alert show={show} variant="danger">
          <Alert.Heading>{alertTexts.returnAlert.header}</Alert.Heading>
          <Paragraph text={alertTexts.returnAlert.text}/>
          <HR />
          <Button href="/etusivu" className="alertBtn btn mainButton m-2 col-3">{alertTexts.posButton}</Button>
          <Button onClick={() => setShow(false)} title="Tyhjennä istunto ja palaa etusivulle" className="alertBtn btn secButton m-2 col-3">{alertTexts.negButton}</Button>
        </Alert>
      </Row>
      <Row id="feedback" className="resultItem w-25 m-auto">
        <Alert show={show2} variant="warning">
          <Alert.Heading>{alertTexts.feedbackAlert.header}</Alert.Heading>
          <Paragraph text={alertTexts.feedbackAlert.text}/>
          <HR />
          <Button href={alertTexts.feedbackAlert.url} target="_blank" className="alertBtn btn mainButton m-2 col-3">{alertTexts.posButton}</Button>
          <Button onClick={() => setShow2(false)} title="Siirry antamaan palautetta" className="alertBtn btn secButton m-2 col-3">{alertTexts.negButton}</Button>
        </Alert>
      </Row>
    </Container>
  );
};

export default AdjustReady;